import React from 'react';
import useStyles from '@front10/helpers/dist/UseStyles';
import Col from '../../../elements/Col';
import Row from '../../../elements/Row';
import Box from '../../../elements/Box';

const styles = {
  header: {
    height: '30px',
    marginBottom: '0.75rem',
  },
  selectorControls: {
    height: '40px',
    marginBottom: '1rem',
  },
  carousel: {
    height: '300px',
    marginBottom: '0.5rem',
  },
  mainFareItem: {
    height: '150px',
    marginBottom: '0.75rem',
  },
  disclaimer: {
    height: '20px',
  },
  selectorControlRight: {
    marginTop: '42px',
    height: '40px',
    marginBottom: '1rem',
  },
  fareItem: {
    height: '100px',
    marginBottom: '0.5rem',
  },
  lastFareItem: {
    height: '25px',
  },
};

const SkeletonFeaturedDestinations = (props) => {
  const [className, style] = useStyles(props);
  const {
    header,
    selectorControls,
    carousel,
    mainFareItem,
    disclaimer,
    selectorControlRight,
    fareItem,
    lastFareItem,
  } = styles;
  return (
    <Box
      className={`${className} fr-skeleton`}
      style={style}
      dataTestId="skeletonFeaturedDestinations"
    >
      <Row gutters>
        <Col xs="8">
          <Row gutters>
            <Col>
              <Box className="fr-skeleton-element" style={header} />
            </Col>
          </Row>
          <Row gutters>
            <Col xs="6">
              <Box className="fr-skeleton-element" style={selectorControls} />
            </Col>
            <Col xs="6">
              <Box className="fr-skeleton-element" style={selectorControls} />
            </Col>
          </Row>
          <Row gutters>
            <Col>
              <Box className="fr-skeleton-element" style={carousel} />
            </Col>
          </Row>
          <Row gutters>
            <Col>
              <Box className="fr-skeleton-element" style={mainFareItem} />
            </Col>
          </Row>
          <Row gutters>
            <Col xs="6">
              <Box className="fr-skeleton-element" style={disclaimer} />
            </Col>
          </Row>
        </Col>
        <Col xs="4">
          <Row>
            <Col>
              <Box className="fr-skeleton-element" style={selectorControlRight} />
            </Col>
          </Row>
          <Row gutters>
            <Col>
              <Box className="fr-skeleton-element" style={fareItem} />
            </Col>
          </Row>
          <Row gutters>
            <Col>
              <Box className="fr-skeleton-element" style={fareItem} />
            </Col>
          </Row>
          <Row gutters>
            <Col>
              <Box className="fr-skeleton-element" style={fareItem} />
            </Col>
          </Row>
          <Row gutters>
            <Col>
              <Box className="fr-skeleton-element" style={fareItem} />
            </Col>
          </Row>
          <Row gutters>
            <Col>
              <Box className="fr-skeleton-element" style={lastFareItem} />
            </Col>
          </Row>
        </Col>
      </Row>
    </Box>
  );
};

SkeletonFeaturedDestinations.componentName = 'SkeletonFeaturedDestinations';

export default SkeletonFeaturedDestinations;
